<template>
  <div class="bg-gray-400 flex justify-center py-1 text-sm">
    <strong>Scheduled Maintenance:&nbsp;&nbsp;</strong>
    <span>
      The system will be unavailable for scheduled maintenance on <strong>{{ time }}</strong>
    </span>
  </div>
</template>
<script lang="ts">
  import { computed, defineComponent } from 'vue';
  import { ObjProp } from '../composables/vuePropTypes';

  export default defineComponent({
    props: {
      maintenance: ObjProp<{
        enabled: boolean;
        start: string;
      }>(),
    },
    setup(props) {
      const time = computed(() => {
        const d = new Date(props.maintenance.start);
        const startHour = d.getHours();
        const endHour = startHour + 2;
        return `${d.toLocaleDateString()} from ${startHour || 12}${startHour > 12 ? 'PM' : 'AM'}
         - 
         ${endHour}${endHour > 12 ? 'PM' : 'AM'}`;
      });

      return {
        time,
      };
    },
  });
</script>
